import axios from "axios";
export const namespaced = true;

export const Config = {
    webcoreURL: process.env.VUE_APP_WEBCORE_API,
    webURL: process.env.VUE_APP_WEB_API,
    coreURL: process.env.VUE_APP_CORE_API,
    corelocal: 'http://localhost:8000/webcore/api'
};

export const client = {
    coreapi: axios.create({
        baseURL: Config.webcoreURL,
        withCredentials: true,
    }),
    coreapifile: axios.create({
        baseURL: Config.webcoreURL,
        withCredentials: true,
        responseType: 'arraybuffer'
    }),
    coreweb: axios.create({
        baseURL: Config.webURL,
        withCredentials: true,
    }),
    corelocal: axios.create({
        baseURL: Config.corelocal,
        withCredentials: true,
    }),
    //clean bekommt keinen throbber!
    core: axios.create({
        baseURL: Config.coreURL
    })
};